<script setup lang="ts">
defineProps<{
  message?: string;
}>();
</script>

<template>
  <div class="flex flex-col items-center space-y-2">
    <AsyncImage
      class="max-w-48 w-full"
      src="/assets/nami/stickers/sad.png"
      alt="No Results"
    />
    <h4 class="font-medium sm:text-lg text-center">
      {{ message || "No Results" }}
    </h4>
  </div>
</template>
